/**
 * Pied de page commun : accès aux quatre pages légales (DECISIONS §11).
 *
 * Présent sur l’accueil et sur l’écran de connexion — les deux points d’entrée du jeu — pour qu’un
 * visiteur puisse lire les conditions **avant** de créer un compte. Tous les libellés viennent du
 * catalogue `legal.piedDePage.*` : rien n’est écrit en dur.
 */
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/** Une entrée du pied de page : route + clé de libellé. */
interface LienLegal {
  readonly route: string;
  readonly cle: string;
}

const LIENS: readonly LienLegal[] = [
  { route: '/mentions-legales', cle: 'legal.piedDePage.mentionsLegales' },
  { route: '/cgu', cle: 'legal.piedDePage.cgu' },
  { route: '/confidentialite', cle: 'legal.piedDePage.confidentialite' },
  { route: '/cookies', cle: 'legal.piedDePage.cookies' },
];

export function PiedDePage() {
  const { t } = useTranslation();
  return (
    <footer className="pied-de-page">
      <nav className="pied-de-page__liens" aria-label={t('legal.piedDePage.titre')}>
        {LIENS.map((lien) => (
          <Link key={lien.route} to={lien.route}>
            {t(lien.cle)}
          </Link>
        ))}
      </nav>
      <p className="pied-de-page__version">
        {t('legal.etiquetteVersion')} {t('legal.version')}
      </p>
    </footer>
  );
}
